import endpoint from "../../config/endpoints";

export const SalesTeamConfigurationJson = {
  showSaveNextBtn: true,
  formPath: "/sales-team-configuration",
  // apiBaseURL: endpoint.region,
  // changeExcel: endpoint.exportData,
  screenTitle: "Sales Team Configuration",
  showAddButton: true,
  showPdfDownload: true,
  // pdfFileName: "Region",
  showExcelDownload: true,
  // excelFileName: "Region",
  // formPathView: "/region-view",

  fieldMetaForHeaderHierarchy: [
    {
      label: "Region",
      controlType: "autocomplete",
      placeHolder: "Select Region",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "regionDetail",
      dataKey: "currentRegionId",
      getListId: "currentRegionId",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "State",
      controlType: "autocomplete",
      placeHolder: "Select State",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "stateDetail",
      dataKey: "currentStateId",
      getListFrom: "currentRegionId",
      getListId: "currentStateId",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Zone",
      controlType: "multiSelect",
      placeHolder: "Select Zone",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "zoneDetail",
      dataKey: "currentZoneIds",
      getListFrom: "currentStateId",
      getListId: "currentZoneIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "District",
      controlType: "multiSelect",
      placeHolder: "Select District",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "districtDetail",
      dataKey: "currentDistrictIds",
      getListFrom: "currentZoneIds",
      getListId: "currentDistrictIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Taluka",
      controlType: "multiSelect",
      placeHolder: "Select Taluka",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "talukaDetail",
      dataKey: "currentTalukaIds",
      getListFrom: "currentDistrictIds",
      getListId: "currentTalukaIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      masterName: "areaDetail",
      dataKey: "currentAreaIds",
      getListFrom: "currentTalukaIds",
      getListId: "currentAreaIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForStockHolderType: [
    {
      label: "Stake Holder Type",
      controlType: "autocomplete",
      placeHolder: "Select Stake Holder ",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "stockHolderTypeDetail",
      dataKey: "stockStakeHolderType",
      getListId: "stockStakeHolderType",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Stake Holder Name",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesPersonDetail",
      getListFrom: "stockStakeHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],

  fieldMetaForFooter: [
    {
      label: "Sequence-Wise Outlet Order",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      labelSM: 7,
      labelMD: 7,
      labelLG: 7,
      valueSM: 5,
      valueMD: 5,
      valueLG: 5,
      dataKey: "sequenceWiseOrder",
      tableDataKey: "sequenceWiseOrder",
      defaultValue: "0",
      radioGroupItems: [
        { label: "Yes", value: "1" },
        { label: "No", value: "0" },
      ],
      isMandatory: true,
    },

    {
      label: "Outlet Edit",
      controlType: "radiogroup",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      labelSM: 3,
      labelMD: 3,
      labelLG: 3,
      valueSM: 9,
      valueMD: 9,
      valueLG: 9,
      dataKey: "outletEdit",
      tableDataKey: "outletEdit",
      defaultValue: "0",
      radioGroupItems: [
        { label: "Yes", value: "1" },
        { label: "No", value: "0" },
      ],
      isMandatory: true,
    },
  ],
};
